import React, { useState, useEffect } from 'react';
import ContestDetailDialog from '../contests/detail-component';
import { useLocation, useParams } from 'react-router-dom';
import { ContestDetail } from '../../types';
import createAxiosInstance from '../../api/axiosConfig';
import { QUEST_BY_CODE, QUEST_BY_ID } from '../../api/endpoint';

const QuestDetail = () => {
  const location = useLocation();
  const { quest } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const { questID: paramQuestID } = useParams();
  const questId = queryParams.get('q') || paramQuestID;
  const [contestDetail, setContestDetail] = useState<ContestDetail | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchQuestDetail = async () => {
    if (!questId) return;
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(false);
      if (queryParams.size > 0) {
        const response = await axiosInstance.get(`${QUEST_BY_CODE}${questId}`);
        setContestDetail(response.data.data);
      } else {
        const response = await axiosInstance.get(`${QUEST_BY_ID}${questId}`);
        setContestDetail(response.data.data[0]);
      }
      setDialogOpen(true);
    } catch (error) {
      console.error('Error fetching contest details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (quest) {
      setContestDetail(quest);
      setDialogOpen(true);
    } else {
      fetchQuestDetail();
    }
  }, [quest, questId]);

  return (
    <div>
      {contestDetail && (
        <ContestDetailDialog open={dialogOpen} contestDetail={contestDetail} setDialogOpen={setDialogOpen} />
      )}
    </div>
  );
};

export default QuestDetail;
